import { useEffect, useMemo } from "react";
import { TrackingEvent } from "../types";
import { useTrackEvent } from "../TrackingContext";

export function useTrackOnMount<Event extends TrackingEvent>(
  event: Event | null,
  enabled = true,
) {
  const trackEvent = useTrackEvent();

  const payload = useMemo(() => JSON.stringify(event), [event]);
  useEffect(() => {
    if (enabled && payload) {
      trackEvent(JSON.parse(payload));
    }
  }, [enabled, trackEvent, payload]);
}
